import { useEffect } from 'react';

const GA_MEASUREMENT_ID = import.meta.env.VITE_GA_MEASUREMENT_ID;
const PLAUSIBLE_DOMAIN = import.meta.env.VITE_PLAUSIBLE_DOMAIN;

/**
 * Analytics component - loads tracking scripts
 *
 * To enable analytics, add to .env:
 *
 * For Google Analytics:
 * VITE_GA_MEASUREMENT_ID=G-XXXXXXXXXX
 *
 * For Plausible Analytics (privacy-friendly):
 * VITE_PLAUSIBLE_DOMAIN=yoursite.com
 */
export const Analytics = () => {
  useEffect(() => {
    // Google Analytics
    if (GA_MEASUREMENT_ID) {
      const script1 = document.createElement('script');
      script1.async = true;
      script1.src = `https://www.googletagmanager.com/gtag/js?id=${GA_MEASUREMENT_ID}`;
      document.head.appendChild(script1);

      const script2 = document.createElement('script');
      script2.innerHTML = `
        window.dataLayer = window.dataLayer || [];
        function gtag(){dataLayer.push(arguments);}
        gtag('js', new Date());
        gtag('config', '${GA_MEASUREMENT_ID}', {
          page_path: window.location.pathname,
        });
      `;
      document.head.appendChild(script2);
    }

    // Plausible Analytics (privacy-friendly alternative)
    if (PLAUSIBLE_DOMAIN) {
      const script = document.createElement('script');
      script.defer = true;
      script.setAttribute('data-domain', PLAUSIBLE_DOMAIN);
      script.src = 'https://plausible.io/js/script.js';
      document.head.appendChild(script);
    }
  }, []);

  return null;
};
